import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { NOTES_QUERY_KEY } from "./useNotes";

type NoteResponse = components["schemas"]["NoteResponse"];

export type ToggleFavoriteNoteVariables = {
  noteId: string;
};

export function useToggleFavoriteNote() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<NoteResponse, Error, ToggleFavoriteNoteVariables>({
    mutationFn: async ({ noteId }) => {
      const { data, error } = await client.POST(
        "/api/notes/{note_id}/favorite",
        { params: { path: { note_id: noteId } } },
      );
      if (error !== undefined) {
        throw new Error(`Failed to toggle favorite on note ${noteId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: NOTES_QUERY_KEY });
    },
  });
}
